import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, AutoComplete } from 'antd';
import { withRouter } from 'react-router-dom';

const SearchFilter = ({ updateQuery, search, setSearch, data, nameField }) => {
  const [autocompleteOptions, setAutocompleteOptions] = useState([]);

  const handleSearch = (value) => {
    setSearch(value);
    setAutocompleteOptions([]);
    updateQuery({ search: value });
  };

  const runAutocompleteOnSearch = (searchText) => {
    if (searchText.length > 0) {
      const seenNames = new Set();
      const options = data
        .filter(item => {
          const name = item[nameField];
          if (!name) return false;
          const nameLower = name.toLowerCase();
          const searchLower = searchText.toLowerCase();
          if (nameLower.includes(searchLower) && !seenNames.has(name)) {
            seenNames.add(name);
            return true;
          }
          return false;
        })
        .map((item, index) => ({ key: index, value: item[nameField] }));
      setAutocompleteOptions(options);
    } else {
      setAutocompleteOptions([]);
    }
    setSearch(searchText);
  };

  return (
    <div className="search">
      <AutoComplete
        options={autocompleteOptions}
        onSelect={(value) => {
          setAutocompleteOptions([]);
          setSearch(value);
          updateQuery({ search: value });
          document.activeElement.blur();
        }}
        onSearch={runAutocompleteOnSearch}
        value={search}
        style={{ width: '350px' }}
      >
        <Input.Search
          placeholder='Search Call Log (Name, Phone Number)'
          allowClear={true}
          onChange={(e) => {
            if (e.target.value.length === 0) {
              handleSearch('');
            }
          }}
          onBlur={() => handleSearch(search)}
          onPressEnter={() => handleSearch(search)}
          onSearch={() => handleSearch(search)}
          style={{ borderRadius: '8px' }}
        />
      </AutoComplete>
    </div>
  );
};

SearchFilter.defaultProps = {
  updateQuery: () => {},
  search: '',
  setSearch: () => {},
  data: [],
  nameField: 'caller_name',
};

SearchFilter.propTypes = {
  updateQuery: PropTypes.func,
  search: PropTypes.string,
  setSearch: PropTypes.func,
  data: PropTypes.array,
  nameField: PropTypes.string,
};

export default withRouter(SearchFilter);
